import { render, staticRenderFns } from "./Telephone.vue?vue&type=template&id=b7197cf4&"
import script from "./Telephone.vue?vue&type=script&lang=ts&"
export * from "./Telephone.vue?vue&type=script&lang=ts&"
import style0 from "./Telephone.vue?vue&type=style&index=0&id=b7197cf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports